import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { FlightLogSummaryEntity } from './flight-log-summary.model';

export enum FlightLogSummaryActionTypes {
  LoadFlightLogSummarys = '[FlightLogSummary] Load FlightLogSummarys',
  AddFlightLogSummary = '[FlightLogSummary] Add FlightLogSummary',
  UpsertFlightLogSummary = '[FlightLogSummary] Upsert FlightLogSummary',
  AddFlightLogSummarys = '[FlightLogSummary] Add FlightLogSummarys',
  UpsertFlightLogSummarys = '[FlightLogSummary] Upsert FlightLogSummarys',
  UpdateFlightLogSummary = '[FlightLogSummary] Update FlightLogSummary',
  UpdateFlightLogSummarys = '[FlightLogSummary] Update FlightLogSummarys',
  DeleteFlightLogSummary = '[FlightLogSummary] Delete FlightLogSummary',
  DeleteFlightLogSummarys = '[FlightLogSummary] Delete FlightLogSummarys',
  ClearFlightLogSummarys = '[FlightLogSummary] Clear FlightLogSummarys',
}

export class LoadFlightLogSummarys implements Action {
  public readonly type = FlightLogSummaryActionTypes.LoadFlightLogSummarys;

  constructor(public payload: { flightLogSummarys: FlightLogSummaryEntity[] }) {}
}

export class AddFlightLogSummary implements Action {
  public readonly type = FlightLogSummaryActionTypes.AddFlightLogSummary;

  constructor(public payload: { flightLogSummary: FlightLogSummaryEntity }) {}
}

export class UpsertFlightLogSummary implements Action {
  public readonly type = FlightLogSummaryActionTypes.UpsertFlightLogSummary;

  constructor(public payload: { flightLogSummary: FlightLogSummaryEntity }) {}
}

export class AddFlightLogSummarys implements Action {
  public readonly type = FlightLogSummaryActionTypes.AddFlightLogSummarys;

  constructor(public payload: { flightLogSummarys: FlightLogSummaryEntity[] }) {}
}

export class UpsertFlightLogSummarys implements Action {
  public readonly type = FlightLogSummaryActionTypes.UpsertFlightLogSummarys;

  constructor(public payload: { flightLogSummarys: FlightLogSummaryEntity[] }) {}
}

export class UpdateFlightLogSummary implements Action {
  public readonly type = FlightLogSummaryActionTypes.UpdateFlightLogSummary;

  constructor(public payload: { flightLogSummary: Update<FlightLogSummaryEntity> }) {}
}

export class UpdateFlightLogSummarys implements Action {
  public readonly type = FlightLogSummaryActionTypes.UpdateFlightLogSummarys;

  constructor(public payload: { flightLogSummarys: Update<FlightLogSummaryEntity>[] }) {}
}

export class DeleteFlightLogSummary implements Action {
  public readonly type = FlightLogSummaryActionTypes.DeleteFlightLogSummary;

  constructor(public payload: { id: string }) {}
}

export class DeleteFlightLogSummarys implements Action {
  public readonly type = FlightLogSummaryActionTypes.DeleteFlightLogSummarys;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearFlightLogSummarys implements Action {
  public readonly type = FlightLogSummaryActionTypes.ClearFlightLogSummarys;
}

export type FlightLogSummaryActions =
  | LoadFlightLogSummarys
  | AddFlightLogSummary
  | UpsertFlightLogSummary
  | AddFlightLogSummarys
  | UpsertFlightLogSummarys
  | UpdateFlightLogSummary
  | UpdateFlightLogSummarys
  | DeleteFlightLogSummary
  | DeleteFlightLogSummarys
  | ClearFlightLogSummarys;
